<script>
    import { setContext } from 'svelte'
    import { writable } from 'svelte/store'
    export let size = 'medium'
    const current = writable({
        last: 0,
        current: 0,
    })
    setContext('size', size)
    setContext('current', current)
    let startIndex = -1
    setContext('setIndex', {
        index: () => {
            startIndex += 1
            $current.last = startIndex
            return startIndex
        },
    })
</script>

<div>
    <span>
        <slot />
    </span>
</div>

<style>
    span {
        position: relative;
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        clip-path: inset(1px 1px 2px 1px round 8px);
    }
    div {
        width: 100%;
        border: 1px var(--color-grey-400) solid;
        border-radius: 8px;
        padding: 0;
        margin: 0;
    }
</style>
